module.exports = __webpack_public_path__ + "media/metronic/_theme/media/icons/svg/Files/Upload-folder-b3b660edf5038c2182520310ed56959a.svg";